/* eslint-disable import/prefer-default-export */
import * as load from '../../../constants/types/shared/LoadingTypes';
import { GET_INSTALLATIONS } from '../../../constants/types/procurement/ProcurementTypes';

export const accountReconciliationReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case GET_INSTALLATIONS:
      return {
        ...state,
        lists: payload.list,
        pages: payload.pages,
        count: payload.count,
        isLoading: false,
      };

    default:
      return state;
  }
};
